module.exports = __webpack_public_path__ + "img/image.d5c6da04.png";